import { css } from '@emotion/react';

const ReturnsBarChartStyles = css`
    .returns-bar-chart-header {
        text-align: center;
    }
`;

export default ReturnsBarChartStyles;
